module.exports = __webpack_public_path__ + "static/media/GA-2100-1A1ER.d76d3169.png";